import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const LokasiCtx = createContext();

function LokasiContext({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<LokasiCtx.Provider value={{ state, dispatch }}>
			{children}
		</LokasiCtx.Provider>
	);
}

export default LokasiContext;
